import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchOrgChartDepEmployee = createAsyncThunk("fetchOrgChartDepEmployee", async (id) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`employee/department/list?limit=1000000&page=1&departmentId=${id}`, config);

	return response.data.data;
});

const orgChartDepEmployeeSlice = createSlice({
	name: "orgChartDepEmployee",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchOrgChartDepEmployee.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchOrgChartDepEmployee.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchOrgChartDepEmployee.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default orgChartDepEmployeeSlice.reducer;
